import { Component, OnInit, inject } from '@angular/core';
import { DeletionService } from '@services/deletion/deletion.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'ft-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
  imports: [MatProgressSpinnerModule, MatButtonModule, MatIconModule]
})
export class DeleteComponent implements OnInit {
    private deletionService = inject(DeletionService);

    deleteOptions: any = {};

    ngOnInit() {
        this.deletionService.deletionService$.subscribe((deleteOptions) => {
            this.deleteOptions = deleteOptions;
        });
    }

    deleteDoc() {
        this.deletionService.deleteDoc();
    }
}

